// extracted by mini-css-extract-plugin
export default {"variantIntroWrapper":"apWBVagJz0","variantIntro":"JFO5yPI4tI","withViewMore":"hT93yYhLsD","viewMoreButton":"hbTA9BUnnu"};